const swiperCol1 = new Swiper(".reviews-swiper", {
  slidesPerView: "auto",
  spaceBetween: 20,
  loop: true,
  speed: 3000, // higher = slower (controls linear scroll speed)
  autoplay: {
    delay: 1500, // no delay between slides
  
  },
centeredSlides: true,
 
  grabCursor: true, 
});


const swiperCol2 = new Swiper(".why-swiper", {
  slidesPerView: 1.6,
  spaceBetween: 20,
  grabCursor: true, 
  keyboard: {
    enabled: true
  },
    scrollbar: { el: ".swiper-scrollbar-why", draggable: true },
    navigation: {
      nextEl: ".swiper-button-next-why",
      prevEl: ".swiper-button-prev-why"
    },
    breakpoints: {
      640: { slidesPerView: 1.15, spaceBetween: 15 }
      
    }
});

const swiperCol3 = new Swiper(".ugc-slider-wrapper", {
  slidesPerView: 4.2,
  spaceBetween: 20,
  grabCursor: true, 
    freeMode: true,
    mousewheel: { forceToAxis: true, invert: true },
  keyboard: {
    enabled: true
  },
  
    navigation: {
      nextEl: ".swiper-button-next-ugc",
      prevEl: ".swiper-button-prev-ugc"
    },
    breakpoints: {
      640: { 
         freeMode: false,
        slidesPerView: 1.15, 
        spaceBetween: 15 
      }
      
    }
});


const swiperCol4 = new Swiper(".new-rev-block-1", {
  slidesPerView: 1.4,
  spaceBetween: 20,
  grabCursor: true, 
  keyboard: {
    enabled: true
  },
    scrollbar: { el: ".swiper-scrollbar-rev-1", draggable: true },
    breakpoints: {
      640: { slidesPerView: 1.15, spaceBetween: 15 }
      
    }
});
const swiperCol5 = new Swiper(".new-rev-block-2", {
  slidesPerView: 1.4,
  spaceBetween: 20,
  grabCursor: true, 
  keyboard: {
    enabled: true
  },
    scrollbar: { el: ".swiper-scrollbar-rev-2", draggable: true },
    breakpoints: {
      640: { slidesPerView: 1, spaceBetween: 15 }
      
    }
});



 
  const swiperCol6 =  new Swiper('.press-swiper-section', {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next-new',
        prevEl: '.swiper-button-prev-new',
      },
      pagination: {
        el: '.swiper-pagination-new',
        type: 'fraction',
      },
      breakpoints: {
       
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        }
      }
    });


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const panel = document.querySelector(`#${header.dataset.target}`);
      const toggle = header.querySelector('.specs-toggle');

      if (header.classList.contains('specs-active')) {
        header.classList.remove('specs-active');
        panel.classList.remove('open');
        toggle.classList.remove('specs-active');
      } else {
        // Close all other panels
        document.querySelectorAll('.specs-accordion-header').forEach(otherHeader => {
          otherHeader.classList.remove('specs-active');
          const otherPanel = document.querySelector(`#${otherHeader.dataset.target}`);
          otherPanel.classList.remove('open');
          otherHeader.querySelector('.specs-toggle').classList.remove('specs-active');
        });

        // Open the clicked panel
        header.classList.add('specs-active');
        panel.classList.add('open');
        toggle.classList.add('specs-active');
      }
    });
  });
});

